import themesConfig from 'app/configs/themesConfig';
import i18n from '../../i18n';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';

const settingsConfig = {
  layout: {
    style: 'layout0', // layout1 layout2 layout3
    config: {}, // checkout default layout configs at app/theme-layouts for example  app/theme-layouts/layout1/Layout1Config.js
  },
  customScrollbars: true,
  direction: i18n.dir(i18n.options.lng) || 'ltr', // rtl, ltr
  theme: {
    main:  ABSUtils.IsDarkMode() ? themesConfig.defaultDark : themesConfig.default,
    navbar: ABSUtils.IsDarkMode() ? themesConfig.defaultDark : themesConfig.default,
    toolbar: ABSUtils.IsDarkMode() ? themesConfig.defaultDark : themesConfig.default,
    footer: ABSUtils.IsDarkMode() ? themesConfig.defaultDark : themesConfig.default,
  },
  /*
   To make whole app auth protected by default set defaultAuth:['admin','staff','user']
   To make whole app accessible without authorization by default set defaultAuth: null
   *** The individual route configs which has auth option won't be overridden.
   */
  defaultAuth: authModules.loggedin,
  /*
    Default redirect url for the logged-in user,
   */
  loginRedirectUrl: '/',
};

export default settingsConfig;
